import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router';
import { FaEye, FaEdit, FaTrash, FaCommentDots } from 'react-icons/fa';
import { useDispatch } from "react-redux";
import { successToast, errorToast } from '../../../Utils/toast';
import { openModal } from "../../../redux/features/modalSlice";
import { STATUS_OPTIONS } from '../../../Constant/leadConstent';
import LeadFilters from '../../../common/leadFilter'; // Apne path ke according
import Pagination from '../../../common/Pagination';
import Swal from "sweetalert2";
import { RemarkReportingDatewiseCount } from "../../../redux/services/RemarkServices/Remark.Services";
function RemarkListCountDatweWisw() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const role = localStorage.getItem("role");
    const isAdmin = role === "admin";
    const [leadData, setLeadData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeFilter, setActiveFilter] = useState("all");
    useEffect(() => {
        fetchLeads();
    }, []);
    const fetchLeads = async (pageNo = 1) => {
        try {
            setLoading(true);
            const payload = {
                page: pageNo,
                // per_page: limit,
            };
            const response = await RemarkReportingDatewiseCount(payload);
            const leads = response?.data || [];
            setLeadData(leads);
        } catch (error) {
            console.log(error);
            errorToast("Failed to fetch leads");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <h3>Loading...</h3>;
    }



    return (
        <div>
            <div className="d-md-flex d-block align-items-center justify-content-between  page-header-breadcrumb">
                <div className="ms-md-1 mb-2 mb-md-0">
                    <h4 className="fw-semibold mb-0">All Lead List</h4>
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item active">All Leads</li>
                    </ol>
                </div>
            </div>
            <div className="st-wrapper-card">
                <div className="st-table-responsive">
                    <table className="table st-custom-table align-middle mb-0">
                        <thead>
                            <tr>
                                <th>Sr.No.</th>
                                <th>Date&Time</th>
                                <th>Total Remarks</th>
                                <th>Total Lead</th>
                                <th className="text-center">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody>

                            {

                                leadData?.map((item, index) => (
                                    <tr key={item.id}>
                                          {/* <td> {(page - 1) * limit + index + 1}</td> */}
                                           <td> { index + 1}</td>
                                        <td>
                                            {item.updated_at
                                                ? (() => {
                                                    const date = new Date(item.updated_at);

                                                    const formattedDate = date
                                                        .toLocaleDateString("en-GB")
                                                        .replace(/\//g, "-");

                                                    const formattedTime = date.toLocaleTimeString("en-GB", {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: false,
                                                    });

                                                    return `${formattedDate} ${formattedTime}`;
                                                })()
                                                : "-"}
                                        </td>
                                        <td>Remarks</td>
                                        <td>Lead</td>

                                        <td>View</td>
                                    </tr>
                                ))
                            }

                        </tbody>
                    </table>

                </div>

            </div>

        </div>
    );
}

export default RemarkListCountDatweWisw;